<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ isEditMode ? $t('base.edit') : $t('base.add_stock') }}
    v-card-content
      v-input-r(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        @input="clearError('name')"
        v-model="form.name")
      v-select(
        :label="$t('base.farm')"
        :options="farmsByCompany"
        :hint="errorMessage('selectedFarm')"
        :invalid="!!errorMessage('selectedFarm')"
        @input="clearError('selectedFarm')"
        v-model="form.farm.id")
    v-card-actions
      v-btn(
        :loading="loading"
        :disabled="!isFormFilled"
        @click="onSubmit")
        | {{ isEditMode ? $t('base.save') : $t('base.add') }}
      delete-btn(
        v-if="isEditMode"
        @delete="onDelete")
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'DetailModal',
  mixins: [formErrorsMixin],
  components: {
    DeleteBtn
  },

  props: {
    selected: {
      type: Object,
      default: null
    }
  },

  mounted () {
    this.loadFarms()
    if (this.selected) {
      this.form.name = this.selected.name
      if (this.selected.farm) {
        this.form.farm.id = this.selected.farm.id
      }
    }
  },

  data: () => ({
    form: {
      name: null,
      farm: {
        id: null
      }
    },
    errors: {
      name: null,
      selectedFarm: null
    },
    loading: false
  }),

  computed: {
    ...mapGetters('farms', [
      'farms'
    ]),

    isEditMode () {
      return this.selected !== null
    },

    farmsByCompany () {
      return this.farms
        .filter(item => item.company.id === +this.$route.params.company_id)
    },

    isFormFilled () {
      return !!this.form.name && !!this.form.farm.id
    }
  },

  methods: {
    ...mapActions('farms', [
      'loadFarms'
    ]),

    async onSubmit () {
      this.loading = true

      if (!this.checkValidData()) return

      const payload = {
        ...this.form,
        company: {
          id: this.$route.params.company_id
        }
      }

      const { errors } = this.isEditMode
        ? await api.stocks.updateById(this.selected.id, payload)
        : await api.stocks.create(payload)

      errors
        ? this.$toasted.error(this.$t('errors.incorrect_data'))
        : this.$emit('close') && this.$emit('update')

      this.loading = false
    },

    checkValidData () {
      const errorCodes = { REQUIRED: '4' }
      let valid = true

      if (!this.form.name) {
        this.errors.name = [errorCodes.REQUIRED]
        valid = false
      }

      if (!this.form.farm.id) {
        this.errors.selectedFarm = [errorCodes.REQUIRED]
        valid = false
      }

      if (!valid) {
        this.loading = false
        return false
      }

      return true
    },

    async onDelete () {
      await api.stocks.deleteById(this.selected.id)
      this.$emit('update')
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
  display: flex;
  gap: 1rem;
}

.v-card__actions button:first-child {
  flex: 1;
}
</style>